import { setConfig } from '@sdk/config/appConfig';

import config from '../config';

const getConfig = () => {
  // @NOTE: This facade is need as long as we base on old config inside angular.
  // With time we will hopefully end up having only 1 config.
  return setConfig({
    AMAZON_S3_BASE_URL: config.SLING_APP_URL,
    APP_URL: config.SLING_APP_URL,
    API_ENDPOINT: config.API_END_POINT,
    KIOSK_APP_URL: config.KIOSK_APP_URL,
    FEATURE_FLAGS: config.FEATURE_FLAGS,
    RECAPTCHA_SITE_KEY: config.RECAPTCHA_SITE_KEY
  });
};

export default getConfig;
